import { BoxV2 as Box, Button, Flex, Table, useTable } from 'portal-commons';
import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/pro-regular-svg-icons';

import ApiKeyCreatedModal from './ApiKeyCreatedModal';
import ApiKeyListingRow from './ApiKeyListingRow';
import { globalGetService, globalPostService } from '@/utils/globalApiServices';

const TABLE_COLUMNS = [
  { id: 'label', label: 'API LABEL', sortable: false },
  { id: 'key', label: 'API KEY', sortable: false },
  { id: 'last_updated', label: 'LAST UPDATED', sortable: false },
  { id: 'active', label: 'ACTIVE', sortable: false },
  { id: 'actions', label: 'ACTIONS', sortable: false },
];

const PAGE_SIZE = 10;

export default function ApiKeysListing() {
  const [addNewApiKey, setAddNewApiKey] = useState(false);
  const [activeAccount, setActiveAccount] = useState({});
  const [isAddingNewKey, setIsAddingNewKey] = useState(false);
  const table = useTable(
    async (filter) => {
      const response = await globalGetService(`dca/api/account`).then(
        (response) => response?.data
      );

      return {
        data: response || [],
        rowsPerPage: PAGE_SIZE,
        total: response?.length || 0,
        page: filter.page,
      };
    },
    {
      deps: [],
      inMemory: true,
    }
  );

  const handleAddNewApiKey = () => {
    setIsAddingNewKey(true);
    globalPostService(`dca/api/account`, {}).then((response) => {
      setIsAddingNewKey(false);
      if (response?.ok) {
        setActiveAccount(response.data);
        setAddNewApiKey(true);
        table.reload();
      }
    });
  };

  const displayAccounts = useMemo(() => {
    const start = (table.pagination.page - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;
    return table.tableData.slice(start, end);
  }, [table.tableData, table.pagination.page]);

  return (
    <>
      <div className="api-keys-listing-wrapper" data-testid="apiKeysListing">
        <div className="title-blk">
          <h3 className="heading2" data-testid="apiKeysListingAddButton">
            <Flex>
              <Box sx={{ marginRight: 'xs' }}>
                <FontAwesomeIcon icon={faKey} />
              </Box>
              <span>API Keys</span>
            </Flex>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                right: 0,
                transform: 'translateY(-50%)',
              }}
            >
              <Button
                shape="square"
                size="small"
                disabled={isAddingNewKey}
                onClick={handleAddNewApiKey}
              >
                Create API Key
              </Button>
            </Box>
          </h3>
        </div>
        <Table
          testId="apiKeyListingTable"
          loading={table.loading}
          className="api-keys-listing-table"
          emptyState=""
          disableHover
          headRows={TABLE_COLUMNS}
          data={displayAccounts}
          renderRow={(data) => {
            return (
              <ApiKeyListingRow
                accountObj={data}
                key={data.id}
                fetchApiAccounts={table.reload}
              />
            );
          }}
          createSortHandler={table.handleSorting}
          handleChangePage={table.handleChangePage}
          pagination={table.pagination}
        />
      </div>
      <ApiKeyCreatedModal
        open={addNewApiKey}
        account={activeAccount}
        onClose={() => {
          setAddNewApiKey(false);
          setActiveAccount({});
        }}
      />
    </>
  );
}
